import { render } from "./MediaUpload.vue?vue&type=template&id=10aa7404&scoped=true"
import script from "./MediaUpload.vue?vue&type=script&lang=js"
export * from "./MediaUpload.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-10aa7404"

export default script